import PropTypes from 'prop-types';
import React, { memo } from 'react';
import classNames from 'classnames';
import { containersUIComponent } from 'ctm-css-themes';
import { withRules } from '../../higher_order_components/with_rules';

/**
 * @returns {ContentCard} A content card
 */
const _ContentCard = memo(({ children, visualProps: { UIComponent } }) => <section className={classNames(containersUIComponent[UIComponent])}>{children}</section>
);

_ContentCard.propTypes = {
    visualProps: PropTypes.shape({
        UIComponent: PropTypes.string
    }),
    children: PropTypes.node
};

_ContentCard.defaultProps = {
    visualProps: {
        UIComponent: 'container_base_0_medium_semi_rounded'
    }
};

const ContentCard = withRules(_ContentCard);

export { _ContentCard, ContentCard };
